import download from "downloadjs";
import RevenueSourceType from "entities/revenueSourceType";
import Month from "entities/month";
import { action, computed, observable } from "mobx";
import type ReportRepository from "repositories/reportRepository";
import type LocalizationService from "services/localizationService";
import type MonthOptionsService from "services/monthOptionsService";
import type OptionsService from "services/optionsService";
import { watchBusy } from "utils/busyWatcher";
import parseFileNameFromAxiosResponse from "utils/parseFileNameFromAxiosResponse";
import ReportsViewModel from "./reportsViewModel";

const navigationName = "revenues";

export default class RevenuesReportsViewModel extends ReportsViewModel {
  @observable revenueSourceType: RevenueSourceType;

  @computed get name() {
    return this.translate("revenues");
  }

  @computed
  get revenueSourceTypes() {
    return this.optionsService.internalEnumOptions(RevenueSourceType);
  }

  @computed get items() {
    return this.revenueSourceTypes.map(item => item.id as RevenueSourceType);
  }

  constructor(
    protected localizationService: LocalizationService,
    protected repository: ReportRepository,
    protected monthOptionsService: MonthOptionsService,
    private optionsService: OptionsService
  ) {
    super(localizationService, repository, monthOptionsService);
    this.revenueSourceType = RevenueSourceType.EshopTransfer;
    this.navigationName = navigationName;
  }

  @action.bound
  @watchBusy
  async onFormSubmit() {
    if (!this.selectedMonth || !this.revenueSourceType) {
      return;
    }
    await this.onDownloadClick(this.selectedMonth, this.revenueSourceType);
  }

  @action.bound
  @watchBusy
  async onDownloadClick(month: Month, revenueSourceType: RevenueSourceType) {
    const fileName = `report_vynosy_${revenueSourceType}_${month.name}.xlsx`;
    try {
      const response = await this.repository.monthlyRevenues(month, revenueSourceType);
      download(response.data, parseFileNameFromAxiosResponse(response, fileName));
    } catch (e) {
      console.error(e);
    }
  }

  translateSourceType(revenueSourceType: RevenueSourceType) {
    return this.localizationService.translateEnum("revenueSourceType", revenueSourceType);
  }
}
